<template>
  <v-app>
    <div style="height: 100% !important; position: relative">
      <button class="menu-btn" ref="refdropdown" v-if="
        showBar && $route.name == 'crm' && getToolbar.user.account_type == 3
      " @click="openMenu()">
        <img src="@/assets/icons/menu.svg" alt="" />
      </button>
      <button class="menu-btn" ref="refdropdown" v-if="
        showBar && $route.name != 'crm' && getToolbar.user.account_type != 3
      " @click="openMenu()">
        <img src="@/assets/icons/menu.svg" alt="" />
      </button>
      <div class="side-menu" :style="{ right: sidebarPosition + '%' }"
        v-closable="{ exclude: ['refdropdown'], handler: 'hideDrop' }">
        <svg xmlns="http://www.w3.org/2000/svg" width="13.736" height="13.94" viewBox="0 0 13.736 13.94" class="close"
          @click="sidebarPosition = -50">
          <g id="Group_1261" data-name="Group 1261" transform="translate(-931.086 -129.086)">
            <line id="Line_228" data-name="Line 228" x1="10.908" y2="11.112" transform="translate(932.5 130.5)"
              fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2" />
            <line id="Line_229" data-name="Line 229" x2="10.908" y2="11.112" transform="translate(932.5 130.5)"
              fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2" />
          </g>
        </svg>
        <ul>
          <li :class="{ active: $route.name === 'feeds' }">
            <div @click="goto('/feeds')">
              <svg xmlns="http://www.w3.org/2000/svg" width="19.194" height="19.18" viewBox="0 0 19.194 19.18">
                <path id="home"
                  d="M35.688,9a.482.482,0,0,0-.515.44v7.833H29.641V12.36a.482.482,0,0,0-.515-.44H25.088a.482.482,0,0,0-.515.44v3.9a.522.522,0,0,0,1.031,0V12.8H28.61v4.477H19.041V6.516L27.106,1l8.259,5.645a.578.578,0,0,0,.725-.068.4.4,0,0,0-.08-.618L27.429.1a.586.586,0,0,0-.645,0L18.2,5.962a.419.419,0,0,0-.193.343V17.717a.482.482,0,0,0,.515.44H35.688a.482.482,0,0,0,.515-.44V9.445A.482.482,0,0,0,35.688,9Z"
                  transform="translate(-17.51 0.523)" fill="#fff" stroke="#fff" stroke-width="1" />
              </svg>
              <span>Feed</span>
            </div>
          </li>
          <li :class="{ active: $route.name === 'messages' }">
            <div @click="goto('/messages')">
              <svg xmlns="http://www.w3.org/2000/svg" width="23.013" height="16.654" viewBox="0 0 23.013 16.654">
                <g id="mail_3_" data-name="mail (3)" transform="translate(0.5 0.5)">
                  <g id="Groupe_682" data-name="Groupe 682" transform="translate(3.834 7.548)">
                    <path id="Tracé_226" data-name="Tracé 226"
                      d="M23.294,19.653a.352.352,0,0,1-.243-.1l-4.084-3.832a.355.355,0,1,1,.486-.517l4.084,3.832a.355.355,0,0,1-.243.613Z"
                      transform="translate(-9.306 -15.111)" fill="#fff" stroke="#fff" stroke-width="1" />
                    <path id="Tracé_227" data-name="Tracé 227"
                      d="M5.757,19.654a.355.355,0,0,1-.243-.613L9.6,15.209a.355.355,0,1,1,.486.517L6,19.557A.351.351,0,0,1,5.757,19.654Z"
                      transform="translate(-5.402 -15.112)" fill="#fff" stroke="#fff" stroke-width="1" />
                  </g>
                  <path id="Tracé_228" data-name="Tracé 228"
                    d="M20.238,20.136H1.775A1.777,1.777,0,0,1,0,18.361V6.257A1.777,1.777,0,0,1,1.775,4.482H20.238a1.777,1.777,0,0,1,1.775,1.775v12.1A1.777,1.777,0,0,1,20.238,20.136ZM1.775,5.192A1.066,1.066,0,0,0,.71,6.257v12.1a1.066,1.066,0,0,0,1.065,1.065H20.238A1.066,1.066,0,0,0,21.3,18.361V6.257a1.066,1.066,0,0,0-1.065-1.065Z"
                    transform="translate(0 -4.482)" fill="#fff" stroke="#fff" stroke-width="1" />
                  <path id="Tracé_229" data-name="Tracé 229"
                    d="M11.2,14.321a1.985,1.985,0,0,1-1.3-.47L.78,5.9a.355.355,0,1,1,.466-.535l9.114,7.95a1.328,1.328,0,0,0,1.673,0l9.1-7.937a.355.355,0,1,1,.467.535l-9.1,7.937A1.983,1.983,0,0,1,11.2,14.321Z"
                    transform="translate(-0.191 -4.713)" fill="#fff" stroke="#fff" stroke-width="1" />
                </g>
              </svg>
              <span>Messages</span>
            </div>
          </li>
          <li :class="{ active: $route.name === 'notifications' }">
            <div @click="goto('/notifications')">
              <svg xmlns="http://www.w3.org/2000/svg" width="20.82" height="20.651" viewBox="0 0 20.82 20.651">
                <g id="notification" transform="translate(0.5 0.5)">
                  <path id="Tracé_230" data-name="Tracé 230"
                    d="M19.35,14.077H17.324V10.385A7.354,7.354,0,0,0,10.43,3.055v-1.5a.47.47,0,1,0-.94,0v1.5A7.354,7.354,0,0,0,2.5,10.385v2.4a.47.47,0,0,0,.94,0v-2.4a6.412,6.412,0,0,1,6.4-6.4H9.98a6.412,6.412,0,0,1,6.4,6.4v3.692H.47a.47.47,0,0,0-.47.47v2.725a.47.47,0,0,0,.47.47H19.35a.47.47,0,0,0,.47-.47V14.547A.47.47,0,0,0,19.35,14.077Zm-.47,2.725H.94V15.017H18.881Z"
                    transform="translate(0 -1.081)" fill="#fff" stroke="#fff" stroke-width="1" />
                  <path id="Tracé_231" data-name="Tracé 231"
                    d="M102.759,218.571a.47.47,0,0,0-.47.47,1.209,1.209,0,0,1-1.208,1.208h-.034a1.209,1.209,0,0,1-1.208-1.208.47.47,0,1,0-.94,0,2.15,2.15,0,0,0,2.147,2.147h.034a2.15,2.15,0,0,0,2.148-2.147A.47.47,0,0,0,102.759,218.571Z"
                    transform="translate(-91.154 -201.537)" fill="#fff" stroke="#fff" stroke-width="1" />
                </g>
              </svg>
              <span>Notifications</span>
            </div>
          </li>
          <li :class="{ active: $route.name === 'consultant-profile' }">
            <div @click="goto('/profile/consultant')">
              <img v-if="getToolbar.user.profile_picture" :src="
                $fullUrl('images/profiles/' + getToolbar.user.profile_picture)
              " />
              <img v-else src="@/assets/avatar.png" alt />
              <span>Profile</span>
            </div>
          </li>
          <li :class="{ active: $route.name === 'settings' }">
            <div @click="goto('/settings')">
              <svg xmlns="http://www.w3.org/2000/svg" width="22.904" height="25.423" viewBox="0 0 22.904 25.423">
                <g id="gear" transform="translate(0.528 0.5)">
                  <g id="Group_1763" data-name="Group 1763" transform="translate(0)">
                    <g id="Group_1762" data-name="Group 1762">
                      <path id="Path_237" data-name="Path 237"
                        d="M30.009,15.646l-2.377-2.152a9.185,9.185,0,0,0,0-2.566l2.377-2.152a.537.537,0,0,0,.106-.644L27.951,4.079a.455.455,0,0,0-.569-.224L24.475,5a8.3,8.3,0,0,0-2.059-1.281l-.535-3.3A.483.483,0,0,0,21.418,0H17.089a.483.483,0,0,0-.464.421l-.535,3.3A8.3,8.3,0,0,0,14.032,5L11.125,3.855a.453.453,0,0,0-.569.224L8.392,8.133a.537.537,0,0,0,.106.644l2.377,2.152a9.185,9.185,0,0,0,0,2.566L8.5,15.646a.537.537,0,0,0-.106.644l2.164,4.054a.455.455,0,0,0,.569.224l2.907-1.149A8.3,8.3,0,0,0,16.091,20.7l.535,3.3a.483.483,0,0,0,.464.421h4.328A.483.483,0,0,0,21.881,24l.535-3.3a8.3,8.3,0,0,0,2.059-1.281l2.907,1.149a.457.457,0,0,0,.569-.224l2.164-4.054A.537.537,0,0,0,30.009,15.646Zm-2.676,3.819-2.786-1.1a.442.442,0,0,0-.464.088,7.373,7.373,0,0,1-2.247,1.4.5.5,0,0,0-.3.39l-.512,3.166H17.484l-.512-3.166a.5.5,0,0,0-.3-.39,7.374,7.374,0,0,1-2.247-1.4.441.441,0,0,0-.464-.088l-2.786,1.1L9.4,16.152l2.278-2.063a.532.532,0,0,0,.162-.477,8.273,8.273,0,0,1,0-2.8.532.532,0,0,0-.162-.477L9.4,8.271l1.769-3.313,2.786,1.1a.441.441,0,0,0,.464-.088,7.373,7.373,0,0,1,2.247-1.4.5.5,0,0,0,.3-.39l.512-3.166h3.538l.512,3.166a.5.5,0,0,0,.3.39,7.374,7.374,0,0,1,2.247,1.4.442.442,0,0,0,.464.088l2.786-1.1L29.1,8.271l-2.278,2.063a.532.532,0,0,0-.162.477,8.274,8.274,0,0,1,0,2.8.532.532,0,0,0,.162.477L29.1,16.152Z"
                        transform="translate(-8.329)" fill="#fff" stroke="#fff" stroke-width="1" />
                      <path id="Path_238" data-name="Path 238"
                        d="M154.821,149.333a5.488,5.488,0,1,0,5.488,5.488A5.495,5.495,0,0,0,154.821,149.333Zm0,9.879a4.391,4.391,0,1,1,4.391-4.391A4.4,4.4,0,0,1,154.821,159.212Z"
                        transform="translate(-143.897 -142.61)" fill="#fff" stroke="#fff" stroke-width="1" />
                    </g>
                  </g>
                </g>
              </svg>
              <span>Settings</span>
            </div>
          </li>
          <li>
            <div @click="logOut">
              <svg id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
                xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path fill="#fff" stroke="#fff"
                    d="m334.667 0h-157.334c-97.782 0-177.333 79.551-177.333 177.333v157.334c0 97.782 79.551 177.333 177.333 177.333h157.333c97.783 0 177.334-79.551 177.334-177.333v-157.334c0-97.782-79.551-177.333-177.333-177.333zm137.333 334.667c0 75.726-61.607 137.333-137.333 137.333h-157.334c-75.726 0-137.333-61.607-137.333-137.333v-157.334c0-75.726 61.607-137.333 137.333-137.333h157.333c75.727 0 137.334 61.607 137.334 137.333zm-38.667-78.667c0 97.782-79.551 177.333-177.333 177.333s-177.333-79.551-177.333-177.333c0-65.281 35.38-122.78 88.65-153.596 9.561-5.529 21.795-2.264 27.327 7.298 5.531 9.562 2.264 21.796-7.297 27.327-42.363 24.505-68.679 70.093-68.679 118.971 0 75.726 61.607 137.333 137.333 137.333s137.332-61.607 137.332-137.333c0-48.878-26.316-94.466-68.68-118.973-9.561-5.53-12.828-17.766-7.297-27.326 5.532-9.563 17.767-12.83 27.327-7.297 53.233 30.794 88.65 88.27 88.65 153.596zm-197.333 0v-157.333c0-11.046 8.954-20 20-20s20 8.954 20 20v157.333c0 11.046-8.954 20-20 20s-20-8.954-20-20z" />
                </g>
              </svg>
              <span>Logout</span>
            </div>
          </li>
        </ul>
      </div>
      <!-- Ask dialog -->
      <vue-confirm-dialog class="delete-consultified-dialog" :class="$store.state.dialog_class"></vue-confirm-dialog>
      <!-- End of dialog -->
      <header-two v-if="showBar"></header-two>
      <!--  -->
      <div class="__toolbar" v-else-if="showLoginBar">
        <div class="content-wrapper">
          <div class="__logo">
            <img @click="goto('/')" src="@/assets/icons/log2.svg" alt width="106px" height="27px" />
          </div>
          <div class="__buttons">
            <button class="sign_in_btn" @click="login">Sign In</button>
            <button class="register_btn" @click="signUp">Register</button>
          </div>
        </div>
      </div>

      <loading v-if="getLoader.isLoading && showBar" :height="25" color="#1ba5a4" :opacity="1" :width="25"
        :active.sync="getLoader.isLoading" :is-full-page="false" :can-cancel="false" background-color="#fff"
        class="loader"></loading>
      <template>
        <v-layout justify-center>
          <v-dialog v-model="getAlert.state" persistent max-width="400">
            <v-card color="#FFFFFF" style="border-radius: 5px">
              <v-layout>
                <div class="card__body">
                  <div class="__header">
                    <label>{{ getAlert.title | validate }}</label>
                  </div>
                  <div class="contents">
                    <p>{{ getAlert.message | validate }}</p>
                  </div>
                  <div class="footer">
                    <button @click="
                      (e) => {
                        $store.dispatch('SET_ALERT', {
                          message: '',
                          title: '',
                          action: true,
                          state: false,
                        });
                      }
                    ">
                      {{ getAlert.yestitle | validate }}
                    </button>
                    <button @click="
                      (e) => {
                        $store.dispatch('SET_ALERT', {
                          message: '',
                          title: '',
                          action: false,
                          state: false,
                        });
                      }
                    " class="cancel">
                      {{ getAlert.notitle | validate }}
                    </button>
                  </div>
                </div>
              </v-layout>
            </v-card>
          </v-dialog>
        </v-layout>
      </template>
      <template>
        <v-layout justify-center>
          <v-dialog v-model="getInfo.state" persistent max-width="400">
            <v-card color="#FFFFFF" style="border-radius: 5px">
              <v-layout>
                <div class="card__body">
                  <div class="__header">
                    <label>{{ getInfo.title | validate }}</label>
                  </div>
                  <div class="contents">
                    <p>{{ getInfo.message | validate }}</p>
                  </div>
                  <div class="footer">
                    <button @click="
                      (e) => {
                        $store.dispatch('SET_INFO', { state: false });
                      }
                    " class="ok-info">
                      Ok
                    </button>
                  </div>
                </div>
              </v-layout>
            </v-card>
          </v-dialog>
        </v-layout>
      </template>
      <router-view v-show="!getLoader.isLoading">
        <slot></slot>
      </router-view>
      <header-phone v-if="showBar"></header-phone>
    </div>
    <!-- Notification widget -->
    <notifications group="status" animation-type="velocity" position="bottom right" :duration="5000">
      <template slot="body" slot-scope="props">
        <div @click="props.close" :class="'notification-template __' + props.item.type">
          <div class="icon-widget">
            <img v-if="props.item.type == 'success'" src="@/assets/notification-icon/success.svg" />
            <img v-if="props.item.type == 'warn'" src="@/assets/notification-icon/warning.svg" />
          </div>
          <div class="not-content">
            <h3 class="title">
              {{ props.item.title }}
            </h3>
            <div class="descr" v-html="props.item.text"></div>
          </div>
        </div>
      </template>
    </notifications>

    <!-- App dialog -->
    <dialogActionMessage></dialogActionMessage>
    <!-- Help Action -->
    <button class="btn-help" v-if="false" @click="goToHelpPage()">
      <img src="@/assets/icons/blue-help.svg" />
      <span v-if="!$store.state.side_bar">Help me</span>
    </button>
  </v-app>
</template>
<script>
import { eventBus } from "./main";
import "vue-loading-overlay/dist/vue-loading.css";
import HeaderTwo from "./components/Partials/HeaderTwo";
import HeaderPhone from "@/components/Partials/HeaderPhone";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    HeaderTwo,
    HeaderPhone,
  },
  data: () => ({
    drawer: null,
    showDrawer: false,
    appNotification: {
      message: "An error occurred!",
      isSuccess: false,
    },
    Unauthanticateroutes: ["welcome", "login"],
    showalert: true,
    prevHeight: 0,
    sidebarPosition: -50,
    crm_menu: false,
    server_public_key: "",
    enable_notification_loading: false,
    show_notification_subscribe_modal: false,
    validate_user_timer: null,
  }),
  beforeCreate() {
    let vm = this;
    // Logged data loader
    if (vm.$localStorage.get("logged_user_data")) {
      let user_data = JSON.parse(vm.$localStorage.get("logged_user_data"));
      sessionStorage.authToken = user_data.access_token;
      sessionStorage.setItem("isLogedIn", true);
      sessionStorage.setItem("account_type", user_data.account_type);
      eventBus.$socket.emit("register", user_data.id);
      vm.$store.commit("AUTH_REQUEST", user_data);
      vm.$store.commit("INITIALIZE_APP_DATA", {
        token: user_data.access_token,
        id: user_data.id,
      });
    }
  },
  mounted() {
    let vm = this;

    if (vm.$localStorage.get("logged_user_data")) {
      if (vm.$localStorage.get("remember_me") == "false") {
        if (!vm.$session.has("temp_session")) {
          vm.$logoutUserAndSaveCurrentPath();
        }
      }
    }

    window.addEventListener(
      "keydown",
      function (e) {
        if (
          (e.ctrlKey || e.metaKey) &&
          (e.which === 61 ||
            e.which === 107 ||
            e.which === 173 ||
            e.which === 109 ||
            e.which === 187 ||
            e.which === 189)
        ) {
          e.preventDefault();
        }
      },
      false
    );

    const handleWheel = function (e) {
      if (e.ctrlKey || e.metaKey) e.preventDefault();
    };
    window.addEventListener("wheel", handleWheel, { passive: false });

    // Notification loader
    vm.validate_user_timer = setInterval(() => {
      if (vm.$localStorage.get("logged_user_data")) {
        setTimeout(() => {
          let permission = Notification.permission;
          if (permission == "default") {
            vm.$localStorage.remove("subscribed_notification");
          }
          if (!vm.$localStorage.get("subscribed_notification")) {
            vm.checkNotificationPermssion();
          }
        }, 1000 * 1);
        clearInterval(vm.validate_user_timer);
      }
    }, 500);
  },
  methods: {
    goToHelpPage() {
      // open new tab
      window.open("https://howto.meritios.com/", "_blank");
    },
    checkNotificationPermssion() {
      let vm = this;
      let permission = Notification.permission;
      if (permission == "granted") {
        vm.show_notification_subscribe_modal = false;
      } else if (permission == "default") {
        vm.getServerPublicKey();
      }
    },
    getServerPublicKey() {
      let vm = this;
      vm.$store
        .dispatch("NOTIFICATION_GET_NODE_VAPID")
        .then((response) => {
          vm.server_public_key = response.data.publicKey;
          vm.show_notification_subscribe_modal = true;
          vm.enableNotification();
        })
        .catch(({ response }) => { });
    },
    enableNotification() {
      let vm = this;
      if (vm.server_public_key) {
        vm.enable_notification_loading = true;
        Notification.requestPermission((permission) => {
          if (permission == "granted") {
            navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
              if (serviceWorkerRegistration.pushManager) {
                var options = {
                  userVisibleOnly: true,
                  applicationServerKey: vm.server_public_key,
                };
                serviceWorkerRegistration.pushManager.subscribe(options).then(
                  (pushSubscription) => {
                    vm.$store
                      .dispatch("NOTIFICATION_SAVE_USER_CHANNELS", {
                        data: JSON.stringify(pushSubscription),
                        app_type: vm.getCurrentBrowser(),
                        app: "web",
                      })
                      .then((response) => {
                        vm.enable_notification_loading = false;
                        vm.show_notification_subscribe_modal = false;
                        vm.$localStorage.set("subscribed_notification", true);
                      })
                      .catch(({ response }) => {
                        vm.enable_notification_loading = false;
                        // vm.$notify({
                        //   group: "status",
                        //   type: "warn",
                        //   title: "OOPS!!!",
                        //   text: "Please try again",
                        // });
                      });
                  },
                  (error) => {
                    vm.enable_notification_loading = false;
                    console.log(error);
                  }
                );
              } else {
                vm.enable_notification_loading = false;
                vm.show_notification_subscribe_modal = false;
                vm.$localStorage.set("subscribed_notification", true);
              }
            });
          }
        });
      } else {
        vm.getServerPublicKey();
        // vm.$notify({
        //   group: "status",
        //   type: "warn",
        //   title: "OOPS!!!",
        //   text: "Please try again",
        // });
      }
    },
    openMenu() {
      let vm = this;
      if (vm.getToolbar.user.account_type == 3) {
        if (vm.$route.name == "crm") {
          const frame = document.querySelector(".iframe-window");
          frame.contentWindow.postMessage(
            { message: "toggleNavigation", value: !vm.crm_menu },
            "*"
          );
        }
      } else {
        vm.sidebarPosition = 0;
      }
    },
    signUp() {
      this.$router.push({ name: "signup" });
    },
    login() {
      this.$router.push({ name: "login" });
    },
    ...mapActions(["INITIALIZE_APP_DATA"]),
    /***** For transitioning pages ****/
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    onCancel() {
      console.log("User cancelled the loader.");
    },
    movetoHome() {
      this.$router.push({ name: "user-profile" });
    },
    hideDrop() {
      this.showDrawer = false;
      this.sidebarPosition = -50;
    },
    goto(path) {
      this.$router.push({ path: path });
      this.showDrawer = false;
      this.sidebarPosition = -50;
    },
    logOut() {
      this.showDrawer = false;
      this.sidebarPosition = -50;
      this.$store.dispatch("AUTH_LOGOUT");
      this.$cookies.remove("project-token");
      this.$cookies.remove("employment-token");
      this.$router.push({ name: "login" });
    },
  },
  computed: {
    ...mapGetters([
      "getLocale",
      "getLoader",
      "getAlert",
      "getToolbar",
      "getInfo",
      "getSubscription",
    ]),
    getRoute() {
      return this.$route;
    },
    showLoginBar() {
      return (
        this.$route.name === "consultant-public-profile" ||
        this.$route.name === "customer-public-profile" ||
        this.$route.name === "assignment-public-profile" ||
        this.$route.name === "supplier-public-profile" ||
        this.$route.name === "profile-view" ||
        this.$route.name === "student-invitation" ||
        this.$route.name === "instructor-invitation"
      );
    },
    showBar() {
      return !(
        this.$route.name === "welcome" ||
        this.$route.name === "login" ||
        this.$route.name === "get-started" ||
        this.$route.name === "create-password" ||
        this.$route.name === "forgot-password" ||
        this.$route.name === "pageNotFound" ||
        this.$route.name === "error" ||
        this.$route.name === "invitation" ||
        this.$route.name === "user-cv" ||
        this.$route.name === "signup" ||
        this.$route.name === "landing_about" ||
        this.$route.name === "log-token" ||
        this.$route.name === "invitation_account" ||
        this.$route.name === "account_activation" ||
        this.$route.name === "project-verification" ||
        this.$route.name === "employment-verification" ||
        this.$route.name === "addmin-create-accounts" ||
        this.$route.name === "pitch-invitation-view" ||
        this.$route.name === "student-invitation" ||
        this.$route.name === "instructor-invitation" ||
        this.$route.name === "Ai-change-password" ||
        !sessionStorage.authToken
      );
    },
  },

  props: {
    source: String,
  },
  created() {
    if (this.showBar) this.$store.dispatch("TITLE_BAR_INFO");
  },
  watch: {},
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
@import "styles/main";

* {
  box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  font-family: "Nunito", sans-serif;
  font-weight: normal;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100% !important;
  margin: 0;
  position: relative;
  float: left;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden !important;
  overscroll-behavior-x: none;

  #app {
    &.container-fluid {
      width: 100%;
      height: 100% !important;
      padding: 0;
      margin-right: auto;
      margin-left: auto;
    }

    @media (min-width: 1500px) {
      /*margin: 0 500px;*/
    }
  }
}

.dropdown-widget {
  position: absolute;
  background: #fff;
  border-radius: 7px;
  box-shadow: 0px 0px 10px #ddd;
  display: flex;
  flex-direction: column;
  width: max-content;
  top: 10px;
  z-index: 9999;

  &.right {
    right: 18px;
  }

  &.left {
    left: 0px;
  }

  .dropdown-item {
    padding: 10px 24px;
    text-decoration: none;
    display: flex;
    align-items: center;
    width: 100%;

    &:hover {
      background: rgb(240, 240, 240);
    }

    .icon {
      margin-right: 15px;
    }
  }
}

.cv-dropdown-widget {
  position: absolute;
  background: #fff;
  border-radius: 7px;
  box-shadow: 0px 0px 10px #ddd;
  display: flex;
  flex-direction: column;
  width: max-content;
  top: 10px;
  z-index: 9999;

  &.right {
    right: -5px;
  }

  &.left {
    left: 0px;
  }

  .dropdown-item {
    padding: 10px 24px;
    text-decoration: none;
    display: flex;
    align-items: center;

    &:hover {
      background: rgb(240, 240, 240);
    }

    .icon {
      margin-right: 15px;
    }
  }
}

.space-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.row {
  display: flex;
  align-items: center;
  position: relative;
}

.align-start {
  align-items: start !important;
}

.h-spacer {
  margin-right: 20px;
}

.vue-notification-group {
  z-index: 99999999999999999 !important;
  right: 10px !important;
  bottom: 65px !important;

  .vue-notification-wrapper {
    height: unset !important;
    margin-bottom: 20px;
    box-shadow: 7px 2px 20px 2px #777777;
    border-radius: 10px;

    .notification-template {
      border-radius: 5px;
      display: flex;
      align-items: center;
      padding: 20px 20px;
      box-shadow: 0px 0px 8px #1b1b1b;

      &.__success {
        background: #ffffff;

        .title {
          color: #1ba5a4;
        }

        .descr {
          color: #000000;
        }
      }

      &.__warn {
        background: #f6f0cb;

        .title {
          color: #685a00;
        }

        .descr {
          color: #000000;
        }
      }

      .icon-widget {
        margin-right: 10px;

        img {
          width: 45px;
        }
      }

      .not-content {
        .title {
          margin-top: 0px;
          margin-bottom: 6px;
          font-size: 15px;
        }

        .descr {
          font-size: 14px;
        }
      }
    }
  }
}

.notification-title {
  font-size: 17px !important;
  border-bottom: 1px solid rgb(247, 202, 134);
  padding-bottom: 4px;
}

.notification-content {
  font-size: 14px !important;
  padding: 10px 0px;
}

.project-item-body {
  .project-info {
    p {
      margin-bottom: 3px;
    }

    p.disc {
      margin-bottom: 8px;
    }

    ul {
      padding-left: 8px;
    }

    ul>li {
      list-style-type: none;
    }

    ul>li::before {
      content: "\2022";
      margin-right: 5px;
    }
  }
}

.employment-item-body {
  .employment-info {
    p {
      margin-bottom: 3px;
    }

    p.disc {
      margin-bottom: 8px;
    }

    ul {
      padding-left: 8px;
    }

    ul>li {
      list-style-type: none;
    }

    ul>li::before {
      content: "\2022";
      margin-right: 5px;
    }
  }
}

.delete-consultified-dialog {
  &.approve-widget {
    .vc-container {
      .vc-btn-grid {
        .vc-btn {
          border: none;
          min-height: 40px !important;
          border-radius: 5px;

          &.left {
            background: #1ba5a4 !important;
            color: #fff;
          }

          &:nth-child(2) {
            color: #808080;
          }
        }
      }
    }
  }

  .vc-container {
    width: 486px;
    border-radius: 5px;
    padding: 25px 0px;

    .vc-title {}

    .vc-text {
      padding-top: 10px;
    }

    .vc-btn-grid {
      padding: 10px 60px;
      grid-column-gap: 40px;

      .vc-btn {
        border: none;
        min-height: 40px !important;
        border-radius: 5px;

        &.left {
          background: #620000;
          color: #fff;
        }

        &:nth-child(2) {
          color: #808080;
        }
      }
    }
  }
}

button {
  outline: none;
}

.floater {
  position: fixed;
  bottom: 0px;
  z-index: 9999999999999999;
  right: 10px;

  @media (min-width: 300px) and (max-width: 630px) {
    bottom: 52px !important;
    right: 0px !important;
  }
}

.app-widget {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}

.error_alert {
  color: red !important;
  font-size: 12px !important;
  display: block;
}

.menu-btn {
  position: fixed;
  right: 4%;
  top: 16px;
  display: none;
  cursor: pointer;
  z-index: 999999;
  outline: none;
  border: none;

  @media (min-width: 300px) and (max-width: 630px) {
    display: unset;
  }
}

.side-menu {
  background: #1885ad;
  position: fixed;
  color: #fff;
  padding: 20px 20px;
  right: -50%;
  width: 150px;
  z-index: 9999000;
  height: 100%;
  top: 50px;
  bottom: 0px;
  transition: 300ms ease-in;

  ul {
    margin-top: 40px;
    padding-left: 0 !important;
    text-align: left;

    svg,
    img {
      width: 18px !important;
      height: 18px !important;
    }

    img {
      border-radius: 100%;
      width: 26px !important;
      height: 26px !important;
      margin-left: -7px;
    }

    li {
      list-style: none;
      text-align: left;
      margin-bottom: 20px;

      div {
        text-decoration: none;
        color: #fff;
        font-size: 12px;
        display: flex;
        align-items: center;

        span {
          margin-left: 10px;
          margin-top: 3px;
          font-size: 14px;
        }
      }
    }

    li.active {
      border-left: 6px solid #fff;
      padding-left: 13px;
      margin-left: -19px;

      span {
        font-weight: 800 !important;
      }
    }
  }
}

.col-md-12 {
  padding: 0 !important; //15px
}

* {
  font-family: "Nunito", sans-serif;
  box-sizing: border-box;
}

/* Ripple effect */
.ripple {
  background-position: center;
  transition: background 0.8s;
}

.ripple:hover {
  background: transparent radial-gradient(circle, transparent 1%, $orange 1%) center/15000%;
}

.ripple:active {
  background-color: $orange;
  background-size: 100%;
  transition: background 0s;
}

/***** For transitioning pages ****/
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  /*transition-property: opacity;*/
  transition-timing-function: ease;
  /*transition-property: opacity;*/
  transition-property: height, opacity;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

$section_padding_left: 250px;
$section_padding_right: 250px;
$section_width: 100%;

.text-right {
  text-align: right !important;
  font-family: "Nunito", sans-serif;
}

.text-center {
  text-align: center !important;
  font-family: "Nunito", sans-serif;
}

$section_padding_left: auto;
$section_padding_right: auto;
$section_width: 800px;

.__toolbar {
  display: flex;
  justify-content: center;
  height: 56px;
  background: linear-gradient(45deg, #1ba5a4, #1885ad);
  padding-right: $section_padding_right;
  padding-left: $section_padding_left;
  padding-top: 10px;
  padding-bottom: 10px;
  position: fixed;
  z-index: 9;
  left: 0px;
  right: 0px;
  top: 0px;

  @media (min-width: 300px) and (max-width: 630px) {
    display: none;
  }

  .content-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: $section_width;

    .__buttons {
      .sign_in_btn {
        outline: none;
        color: #fff;
        width: 90px;
        height: 35px;
        font-family: "Nunito", sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        background: transparent;
      }

      .register_btn {
        width: 90px;
        height: 35px;
        font-family: "Nunito", sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        border-radius: 0.8vh;
        background-color: #fff;
        color: #00749f;
        outline: none;
        border: none;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.btn-help {
  color: #0884af;
  position: fixed;
  bottom: 66px;
  right: 40px;
  z-index: 99;
  display: flex;
  align-items: center;

  img {
    margin-right: 10px;
  }
}

.card__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  justify-content: center;

  .__header {
    margin-top: 20px;

    label {
      font-family: "Nunito", sans-serif;
      font-size: 16px;
      font-weight: 700;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.35;
      letter-spacing: 0.01px;
      text-align: center;
      color: #808080;
    }
  }

  .contents {
    align-self: center;
    display: flex;
    margin-top: 20px;
    font-size: 14px;
    flex-direction: column;
    justify-content: center;

    p {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.31;
      letter-spacing: 0px;
      text-align: center;
      color: #808080;
    }
  }

  .footer {
    margin-bottom: 20px;
    margin-top: 10px;

    button {
      width: 80px;
      height: 20px;
      color: #fff;
      cursor: pointer;
      outline: none;
      border: none;
      font-size: 12px;
      margin: 0 10px;
      border-radius: 5px;
      background-color: #620000;
    }

    .cancel {
      background: transparent;
      color: #6e6e6e;
    }

    .ok-info {
      background: #1890a9;
      color: #fff;
    }
  }
}
</style>

<style lang="scss">
.title {}
</style>